import React from 'react';
import './Home.css';

function Home() {
  return (
    <div className="text">
      <h1>Welcome to Our Website</h1>
      <p>
        Welcome to WazaCode Math Magicians! We&apos;re thrilled to have you here.
        Whether you&apos;ve stumbled upon us by chance or arrived with a specific purpose,
        we hope you find exactly what you&apos;re looking for.
        Our website is a place of discovery,
        where you can explore a world of information, inspiration, calculations
        and opportunities.
      </p>
      <p>
        Take your time to browse, engage, and learn.
        If you ever have questions or need assistance,
        don&apos;t hesitate to reach out to our friendly team.
        Thank you for choosing us as your online destination.
        We look forward to making your stay here enjoyable and enriching.
      </p>
    </div>
  );
}

export default Home;
